import _ from "underscore";
import RollingLimiter from "../../utils/limiter";
import { isAppInBackground, isBackgroundModeEnabled } from "../../utils/native/nativeHelpers";
import { getServerDate } from "../../utils/storage/date";
import { MobileActions } from "../../store/mobile/actions";
import pageHTML from "./backgroundTest.tmpl";
import DebugPageView from "./debugPageView";

    export default class BackgroundTestView extends DebugPageView {

        private readonly template = _.template(pageHTML);
        private readonly limiter = new RollingLimiter<GeolocationPosition>({ sizeLimit: 20 });
        private readonly timerId: any = null;
        private readonly watchId: any = null;
        private readonly positionKey = "position";
        private counter = 0;

        constructor (options) {
            super(options);
            this.watchId = navigator.geolocation.watchPosition(
                (pos) => {
                    this.limiter.add(this.positionKey, pos);
                },
                () => {}
            );

            this.timerId = setInterval(() => {
                this.counter++;
                this.render();
            }, 1000);
        }

        render () {
            let positions = this.limiter.getData(this.positionKey);
            let lastPositionTime = Infinity;
            let lastPosition = {
                latitude: 0,
                longitude: 0
            };

            if (positions.length > 0) {
                lastPositionTime = ((getServerDate().getTime() - positions[positions.length - 1].data.timestamp) / 1000);
                lastPosition = {
                    latitude: parseFloat(positions[positions.length - 1].data.coords.latitude.toFixed(3)),
                    longitude: parseFloat(positions[positions.length - 1].data.coords.longitude.toFixed(3))
                };
            }

            this.el.innerHTML = this.template({
                backgroundState: isAppInBackground(),
                runInBackgroundAllowed: isBackgroundModeEnabled(),
                backgroundCounter: this.counter,
                lastPositionTime,
                lastPosition
            });

            this.app.store.dispatch(MobileActions.setPageState({
                title: "Background Test",
                pageLevel: 2
            }));

            return this;
        }

        remove () {
            window.clearInterval(this.timerId);
            navigator.geolocation.clearWatch(this.watchId);
            this.limiter.clear(this.positionKey);
            super.remove();
            return this;
        }
    }